import { delay, put, takeEvery, takeLatest } from 'redux-saga/effects';
import { poker } from '../actions/actionTypes';
import ClientAPI from '../../ClientAPI/ClientAPI';
import * as paths from './../../ClientAPI/paths';
import {
  pokerTournamentsByTournamentTypesLoaded,
  pokerTrTLoaded,
  pokerTrTLoading,
} from '../actions/poker_tournament_tickets';
import Utils from '@/modules/casino/utils/Utils';

function* getPlayerId() {
  const store = ClientAPI.getStore();
  const state = store.getState();
  const player = state?.profile?.client_player_id ?? null;

  if (!player) {
    yield delay(100);
    return yield getPlayerId();
  }

  return player;
}

function* fetchPokerTournamentTickets() {
  // const axios = ClientAPI.getInstance();
  const axios = yield Utils.getAxiosWithToken();
  const store = ClientAPI.getStore();
  const state = store.getState();
  const player = yield getPlayerId();

  console.log('[fetchPokerTournamentTickets] saga RUNNING', { player, state });

  // TODO: REMOVE THIS HARD CODED DATA
  // const hardcodeddata = [
  //   {
  //     amount: 21032,
  //     currency: 'USD',
  //     description: 'Giveaway',
  //     expirationDate: 1753420680000,
  //     grantDate: '2025-07-01T13:47:18.887+00:00',
  //     referenceId: 137158499276,
  //     status: 9,
  //     tournamentTypes: [779],
  //   },
  //   {
  //     amount: 2000,
  //     currency: 'USD',
  //     description: 'Giveaway',
  //     expirationDate: 1753420680000,
  //     grantDate: '2025-07-01T13:55:13.6+00:00',
  //     referenceId: 137158499559,
  //     status: 5,
  //     tournamentTypes: [779],
  //   },
  // ];
  // yield put(pokerTrTLoaded(hardcodeddata));
  // return;

  if (
    window?.config?.poker?.enablePokerTrT !== '1' ||
    !player ||
    ['user', 'token'].indexOf(state.authentication.auth_type) === -1 ||
    state.authentication.access_token === null
  ) {
    console.log('[fetchPokerTournamentTickets] saga SKIPPED', {
      player,
      authType: state.authentication.auth_type,
      accessToken: state.authentication.access_token,
      enablePokerTrT: window?.config?.poker?.enablePokerTrT,
    });
    yield put(pokerTrTLoaded([]));
    return;
  }

  yield put(pokerTrTLoading(true));

  try {
    const response = yield axios({
      url: paths.poker.GET_PLAYER_BONUSES,
      method: 'post',
      data: {
        playerId: player,
      },
    });

    console.log('[fetchPokerTournamentTickets] saga response', response);

    if (!response || !response.result) {
      throw new Error('Invalid response for poker tournament tickets');
    }

    if (response.errorDescription) {
      throw new Error(`Error fetching poker tournament tickets: ${response.errorDescription}`);
    }

    if (response && response.result) {
      yield put(pokerTrTLoaded(response.result.bonuses ?? []));
    }
  } catch (e) {
    console.log('fetchPokerTournamentTickets err', e);
    yield put(pokerTrTLoading(false));
  }
}

function* fetchPokerTournamentsByTournamentTypes(action) {
  const axios = ClientAPI.getInstance();
  const store = ClientAPI.getStore();

  console.log('[fetchPokerTournamentByTrT] saga RUNNING', { action });

  // TODO: REMOVE THIS HARD CODED DATA
  // const hardcodeddata = [
  //   {
  //     gameType: 100,
  //     id: 116778503,
  //     name: '$20 blast v4 - 2 millions',
  //     seatingTime: '1970-01-01T00:00:00Z',
  //     status: 4,
  //   },
  //   {
  //     gameType: 100,
  //     id: 116778505,
  //     name: '$20 blast v4 - 2 millions',
  //     seatingTime: '1970-01-01T00:00:00Z',
  //     status: 4,
  //   },
  // ];
  // yield put(
  //   pokerTournamentsByTournamentTypesLoaded({
  //     trt: action.trt,
  //     trs: hardcodeddata,
  //   }),
  // );
  // return;

  if (window?.config?.poker?.enablePokerTrT !== '1' || !action.trt) {
    console.log('[fetchPokerTournamentByTrT] saga SKIPPED', {
      enablePokerTrT: window?.config?.poker?.enablePokerTrT,
      action,
    });

    return;
  }

  yield put(pokerTrTLoading(true));

  try {
    const response = yield axios({
      url: paths.poker.GET_TOURNAMENTS_BY_TRT,
      method: 'post',
      data: {
        tournamentTypes: action.tournamentTypes,
      },
    });

    console.log('[fetchPokerTournamentByTrT] saga response', response);

    yield put(
      pokerTournamentsByTournamentTypesLoaded(
        response.result?.tournaments
          ? {
              trt: action.trt,
              tournaments: response.result.tournaments,
            }
          : {
              trt: action.trt,
              tournaments: [],
            },
      ),
    );
    yield put(pokerTrTLoading(false));
  } catch (e) {
    console.log('fetchPokerTournamentByTrT err', e);
    yield put(pokerTrTLoading(false));
  }
}

export default function* watchPokerTournamentTicketsSaga() {
  yield takeEvery(poker.POKER_TRT_FETCH, fetchPokerTournamentTickets);
  yield takeLatest(poker.POKER_TRT_FETCH_TOURNAMENTS_BY_TOURNAMENT_TYPES, fetchPokerTournamentsByTournamentTypes);
}
